import {Nav, NavItem, NavLink} from "reactstrap";
import React from "react";

export const UpdateSellerNavItems = (props) => {
    const { VerticleTab, setVerticleTab, errors, showShopifySyncSettingsTab, shopifyUkDetection } = props;

    const hasAnyError = (fields) => fields.some((f) => !!errors?.[f]);
    const warnIcon = <i className="icofont icofont-warning-alt"></i>;

    const tab1 = hasAnyError(['name','shopName','email','number','pdCountry','location','pdCity','commission','sellerId']);
    // Tab 2 is separate Brand module (save button not used there)
    const tab3 = hasAnyError(['storeDescription','sellerDescription','sellerSince','otherPolicy','storeDescriptionHeading','sellerDescriptionHeading','otherInformationHeading','otherPolicyHeading','otherInformation','deliveryDays','deliveryMethodName','deliveryTime','returnDays','refundDays']);
    const tab4 = hasAnyError(['minOrder','deliveryInfo','chargeTax','socialFacebook','socialInstagram','socialTwitter','instagramWidgetCode','shippingOption']);
    const tab5 = hasAnyError(['returnCancellationPolicyHeading','returnCancellationPolicy','sellerProfileHeading','sellerProfileLink','sellerShopHeading','sellerShopLink','brandSizeChartHeading','brandSizeChartLink','sizeChartHeading','sizeChartLink','promotionHeading','promotionLink','tradeShowHeading','tradeShowLink','designedMadeInHeading','designedMadeInLink','shippingValidityHeading','shippingValidityLink']);
    const tab6 = hasAnyError(['customerFullName','customerMobileNumber','customerEmail']);
    const tab7 = hasAnyError(['returnsFirstAddress','returnsCity','returnsCountry','returnsPostcode']);
    const tab8 = hasAnyError(['storeName','apiKey','apiSecretKey','secretKey']);

    const tab11 = hasAnyError([
        "syncInventory",
        "inventoryLocationIds",
        "stockBufferValue",
        "syncPrices",
        "ukPriceSyncMode",
        "ukCatalogId",
        "ukCatalogFallbackToContextual",
    ]);

    return (
        <Nav className="nav flex-column nav-pills">
            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '1' ? 'active-element' : ''} onClick={() => setVerticleTab('1')}>
                    Primary Details {tab1 ? warnIcon : ""}
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '2' ? 'active-element' : ''} onClick={() => setVerticleTab('2')}>
                    Brand Details
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '3' ? 'active-element' : ''} onClick={() => setVerticleTab('3')}>
                    Seller & Store Description {tab3 ? warnIcon : ""}
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '4' ? 'active-element' : ''} onClick={() => setVerticleTab('4')}>
                    Extra Information {tab4 ? warnIcon : ""}
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '5' ? 'active-element' : ''} onClick={() => setVerticleTab('5')}>
                    Heading & Links {tab5 ? warnIcon : ""}
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '6' ? 'active-element' : ''} onClick={() => setVerticleTab('6')}>
                    Customer Service Contact Details {tab6 ? warnIcon : ""}
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '7' ? 'active-element' : ''} onClick={() => setVerticleTab('7')}>
                    Returns Warehouse Address {tab7 ? warnIcon : ""}
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '8' ? 'active-element' : ''} onClick={() => setVerticleTab('8')}>
                    Shopify Details {tab8 ? warnIcon : ""}
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '9' ? 'active-element' : ''} onClick={() => setVerticleTab('9')}>
                    Upload Images
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink href="#javascript" className={VerticleTab === '10' ? 'active-element' : ''} onClick={() => setVerticleTab('10')}>
                    Banner Images
                </NavLink>
            </NavItem>

            {showShopifySyncSettingsTab && (
                <NavItem>
                    <NavLink href="#javascript" className={VerticleTab === "11" ? "active-element" : ""} onClick={() => setVerticleTab("11")}>
                        Shopify Sync Settings {tab11 ? warnIcon : ""}
                    </NavLink>
                </NavItem>
            )}
        </Nav>
    );
};
